<template>
	<div class="wrapper">
		<b-container>
			<b-row class="justify-content-center"
			>
				<div class="title mt-3" style="border:none">
					{{$t('lang.CFSPDC')}}
				</div>
			</b-row>
			<intro-scroll class="intro-scroll"
				:introList="introList"
			></intro-scroll>
			<div class="donor-box">
				<div v-for="(item, index) in dataList" :key="index">
					<layout :cols="6" :md="3" :dataList="item.value">
						<template v-slot:title>
							<div class="title">{{ item.name }} {{$t('lang.Prizedonor')}}</div>
						</template>
					</layout>
				</div>
			</div>
		</b-container>
	</div>
</template>
<script>
import layout from '@/components/layout.vue'
import introScroll from '@/components/introScroll.vue'
export default {
	components: {
		introScroll,
		layout,
	},
	data() {
		return {
			dataList: [],
			introList: [],
			characterList: [],
		}
	},
	created() {
		this.getCharacter()
        this.getMasterCharacter()
        this.getCharacterYears()
	},
	methods: {
        getCharacterYears(){
            this.$api.characterYears()
            .then(res=>{
            })
        },
		getMasterCharacter() {
			this.$api
				.characterList({ type: 3 , sortType:'prize'}) //带文本捐赠人列表
				.then((res) => {
					this.introList = res.data
				})
		},
		getCharacter() {
			this.$api
				.characterList({ type: 2 }) //捐赠人列表
				.then((res) => {
					this.characterList = res.data
					this.dataList = this.formatArr(
						this.characterList,
						'awardName'
					)
				})
		},
		formatArr(arr, keyword) {
			let obj = {}
			arr.forEach((item) => {
				if (Object.keys(obj).indexOf(String(item[keyword])) === -1) {
					obj[item[keyword]] = []
				}
				obj[item[keyword]].push(item)
			})
			let keyArr = []

			keyArr = Object.keys(obj)
			let valueArr = []
			keyArr.forEach((item) => {
				for (let i in obj) {
					if (item == i) valueArr.push(obj[i])
				}
			})
			let newArr = keyArr.map((item, index) => {
				return {
					name: item,
					value: valueArr[index],
				}
			})
			return newArr
		},
	},
}
</script>
<style lang="scss" scoped>
.title {
	font-size: 1.2rem;
    text-align: center;
    padding: 2rem;
    color: #cfaf75;
	margin-top: 2rem;
    font-weight: bold;
    border-bottom: 0.1rem solid #ececec;
}
@media (max-width: 768px) {
	.title{
		padding-top: 1rem;
		border-bottom: none;
	}
	.donor-box{
		margin-top: -3rem;
	}
	.intro-scroll::v-deep{
		margin-top: -6rem;
		transform: scale(0.88);
	}
}

</style>
